import React, { useEffect, useState } from 'react';

interface MobileContainerProps {
  children: React.ReactNode;
  maxWidth?: number;
  paddingDesktop?: number;
  paddingMobile?: number;
  topPad?: number; // usually nav height
  bottomPadMobile?: number; // space for bottom nav
  className?: string;
  style?: React.CSSProperties;
}

const MobileContainer: React.FC<MobileContainerProps> = ({
  children,
  maxWidth = 800,
  paddingDesktop = 20,
  paddingMobile = 12,
  topPad = 76,
  bottomPadMobile = 72,
  className,
  style,
}) => {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    try { return window.innerWidth <= 768; } catch { return false; }
  });
  useEffect(() => {
    const onResize = () => { try { setIsMobile(window.innerWidth <= 768); } catch {} };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div
      className={className}
      style={{
        maxWidth,
        margin: '0 auto',
        padding: isMobile ? paddingMobile : paddingDesktop,
        paddingTop: topPad,
        paddingBottom: isMobile ? bottomPadMobile : paddingDesktop,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default MobileContainer;
